export default __webpack_public_path__ + "static/media/steps.ab4f87f8.svg";